import React from 'react';
import styles from './faq.module.scss'
import {Row, Col, Table} from "react-bootstrap";
import {formatDate, formatDateTime, toCurrency} from "../../../helpr/helper";
import detailsArrowIcon from "../../../assets/table-details-arrow.svg";
import {ISSUER_ROLE, UNDERWRITER_ROLE} from "../../../helpr/constants";

const FAQ = ({role}) => {
  console.log(role);
  return (
    <div className={styles['faq']}>
      <Row>
        <Col lg={12}>
          <Row>
            <Col lg={12}>
              <div className={styles['header']}>
                Frequently Asked Questions
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              {role === ISSUER_ROLE ? renderIssuerFAQ() : renderSaFAQ()}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

const renderIssuerFAQ = () => {
  return (
    <Table className={styles['table']} responsive>
      <thead className={styles['white-color']} >
        <tr>
          <th>Question</th>
          <th>Answer</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            What is e-SIP?
          </td>
          <td className={styles['answer']}>
            e-SIP or e-Securities Issue Portal is a user-friendly and easy-to-use online system that will streamline listing and
            enrollment of securities as well as the key activities of
            Selling Agents for their Applicant-Clients to purchase the
            securities on offer in the Primary Market and thereafter
            become confirmed holders in the security’s registry.
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            Who are the Users of the
            e-SIP?
          </td>
          <td className={styles['answer']}>
            <ol className={styles['alpha']}>
              <li>
                Corporate Issuers applying to list or enroll their
                securities on the PDEx Fixed Income Market, and
                who appoint PDTC as their Registrar and Paying
                Agent
              </li>
              <li>
                Underwriter - Arrangers appointed by the Issuer for
                the security to be listed / enrolled
              </li>
              <li>
                Selling Agents appointed by the Issuer for the
                primary distribution of the security to be listed /
                enrolled
              </li>
              <li>
                Applicant-Clients invited by Selling Agents to apply
                to purchase the security on offer
              </li>
            </ol>
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            How does an Issuer,
            Underwriter or Selling
            Agent apply for access
            to e-SIP?
          </td>
          <td className={styles['answer']}>
            Issuers that want to apply to list / enroll their to-be-issued
            securities on the PDEx Fixed Income Market may request for
            the Institutional Subscription Form from the PDEx Listing
            Unit at email address: market.operations@pds.com.ph or
            telephone number: +63.2.8884.5006. <br/> <br/>
            The PDEx Listing Unit will then send an invitation to the
            Issuer with the Institutional Subscription Form which
            contains the Terms of Use and Privacy Policy. The Issuer will
            designate its appointed Selling Agents and Underwriters in
            the Subscription Form who will also be invited to submit
            their Institutional Subscription Form.<br/> <br/>
            Once the Institutional Subscription Form has been
            completed and submitted to the PDEx Listing Unit, Market
            Services will email the e-SIP Registration Profile Form to the
            Authorized Users. Once the e-SIP Registration Profile Form
            is completed, the Issuer, Underwriters and Selling Agents
            will then receive an email containing their credentials to logon to the e-SIP.<br/> <br/>
            Once an Issuer has their access credentials, he may now
            initiate a listing/enrollment event by filling up a Security
            Information Page for the security/s that it wants to
            list/enroll. Apart from inputting the details of the to-belisted security, the Issuer shall also indicate the
            underwriters/Arrangers and Selling Agents that will be
            involved in the issuance, listing and registry on-boarding
            activities for the security. The issuer must also upload the
            required listing/enrollment and PDTC documents.
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            Is e-SIP available
            anytime?
          </td>
          <td className={styles['answer']}>
            e-SIP shall be available each time there will be a new
            security or new tranches of securities to be offered and
            listed on PDEx. After the security or tranche of securities is
            listed, access to e-SIP by Selling Agents and their ApplicantClients shall cease.
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            How many Users can
            each Selling Agent and
            Underwriter apply for
            access to e-SIP for their
            Institution?
          </td>
          <td className={styles['answer']}>
            Each appointed Underwriter and/or Selling Agent is allowed
            a maximum of 10 users per role, per Institution. “Role” here
            refers to their role in the issuance (i.e., as Underwriter, as
            Selling Agent as applicable).
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            What are the Business
            Continuity Plans for the
            e-SIP?
          </td>
          <td className={styles['answer']}>
            The e-SIP has been developed and shall operate on cloudbased services. Its business continuity plan is therefore
            premised on the cloud platform hosting the portal in global
            multiple-availability zones that each feature their own high
            resiliency and high availability environments.
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            What are e-SIP's
            security features?
          </td>
          <td className={styles['answer']}>
            The e-SIP uses a secure connectivity (https) protocol and
            data are encrypted by default. <br/><br/>
            In addition to assigned usernames and passwords, access
            will be secured with Multi-Factor Authentication (MFA)
            which means that when you attempt to access the portal,
            you are sent an email to your registered email address with
            a One Time Password (OTP). Since you are generally the
            only one with access to your email, you would be notified of
            any attempt to log into your account. The OTP, which is
            required to access the portal, will be valid for 3 minutes
            upon receipt. Email confirmations are also sent to your
            registered email address. As a security measure, if no user
            activity on the e-SIP is detected within 15 minutes, the
            system will log out the user.
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            What happens if I
            entered a wrong OTP?
          </td>
          <td className={styles['answer']}>
            After three (3) failed attempts, you will be redirected to the
            login page. You can authenticate again by entering your username and password. A new OTP will be sent to your
            registered email address.
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            Can the Selling Agents
            still accept manual
            Application To Purchase
            (ATPs)?
          </td>
          <td className={styles['answer']}>
            Yes, the appointed Selling Agents of the particular issuance
            can still accept manual ATPs, but these will no longer be
            submitted to PDTC in paper form. The Portal has a bulk
            upload facility, following the sales report template, which
            the Selling Agents can use for clients who applied through
            manual means.
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            Will there be a user
            training on the e-SIP for
            Applicant-Clients?
          </td>
          <td className={styles['answer']}>
            Yes. A video demonstration on the use of the e-SIP will be
            made available. The e-SIP is designed to be a user-friendly,
            easy-to-use platform for Applicant-Clients and shall have an
            FAQ section for Applicant-Client users.
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            What is the Data Privacy
            Framework for the data
            stored in the e-SIP?
          </td>
          <td className={styles['answer']}>
            All client information collected by the Selling Agent through
            the portal will be maintained until Issue Date and deleted
            thereafter. Consistent with the current framework, the
            Selling Agent will remain as the Data Collector and the
            Registrar maintains its role as the Data Processor. Further
            details are on the Privacy Notice embedded on e-SIP's
            webpage.
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            Will the existing Issuers
            be pre-enrolled in the eSIP?
          </td>
          <td className={styles['answer']}>
            Yes, to facilitate the onboarding process, all existing Issuers
            will be pre-enrolled in the e-SIP subject to their
            confirmation/acceptance of the pre-entered details.
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            Can our existing
            Application To Purchase
            (ATP) system interface
            with the e-SIP?
          </td>
          <td className={styles['answer']}>
            Yes, the e-SIP was designed to be interoperable with
            existing proprietary systems of the capital market
            stakeholders.
          </td>
        </tr>
        <tr>
          <td  className={`${styles['white-color']} ${styles['question']}`}>
            Will the due date for the
            submission of the Sales
            Report still be 3
            Business Days before
            Issue Date?
          </td>
          <td className={styles['answer']}>
            Selling Agents may submit up to 9:00 A.M., 1 Business Day
            before the Issue Date. <br/><br/>
            This is a two-day improvement from the previous manual
            process.
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            What are the minimum
            system requirements to
            access the e-SIP?
          </td>
          <td className={styles['answer']}>
            The e-SIP is accessible via any of the following device
            operating systems and browsers: Windows 10, MacOS, iOS,
            and Android using all modern browsers like Chrome, Safari,
            Firefox, and Opera.
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            What are the acceptable
            passwords conventions
            for the e-SIP?
          </td>
          <td className={styles['answer']}>
            For security purposes, the e-SIP has specifications for the
            password convention.
            <ul>
              <li>
                Combination of Alphanumeric with at least one (1)
                special character
              </li>
              <li>
                Minimum number of characters: 8
              </li>
              <li>
                Allowed special characters: !@#$%^&*()
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td className={`${styles['white-color']} ${styles['question']}`}>
            Is the
            Arranger/Underwriter
            function required?
          </td>
          <td className={styles['answer']}>
            The Underwriter/ Arranger function on e-SIP is optional. It is
            only relevant when an Issuer assigns an Underwriter as the
            Designated Person, making the latter a substitute to the
            former, and having controls the Issuer distinctively has. <br/><br/>
            In the next phases of e-SIP, an Underwriter will be able to
            upload documents on an Issuer’s behalf even if they are not
            the Designated Person.
          </td>
        </tr>
      </tbody>
    </Table>
  )
}

const renderSaFAQ = () => {
  return (
    <Table className={styles['table']} responsive>
      <thead className={styles['white-color']} >
      <tr>
        <th>Question</th>
        <th>Answer</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          What is e-SIP?
        </td>
        <td className={styles['answer']}>
          e-SIP or e-Securities Issue Portal is a user-friendly and easyto-use online system that will streamline listing and
          enrollment of securities as well as the key activities of
          Selling Agents for their Applicant-Clients to purchase the
          securities on offer and thereafter become confirmed
          holders in the security’s registry.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          Who are the Users of the
          e-SIP?
        </td>
        <td className={styles['answer']}>
          <ol className={styles['alpha']}>
            <li>
              Corporate Issuers applying to list or enroll their
              securities on the PDEx Fixed Income Market, and
              who appoint PDTC as their Registry and Paying Agent
            </li>
            <li>
              Underwriters / Arrangers appointed by the Issuer
              for the security to be listed / enrolled,
            </li>
            <li>
              Selling Agents appointed by the Issuer for the
              primary distribution of the security to be listed /
              enrolled
            </li>
            <li>
              Applicant-Clients invited by Selling Agents to apply
              to purchase the security on offer
            </li>
          </ol>
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          How do we access e-SIP?
        </td>
        <td className={styles['answer']}>
          The e-SIP can be accessed through a secure portal from any
          of the following devices- desktop, laptop, smartphone or
          tablet.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          How does an
          Underwriter or Selling
          Agent apply using
          e-SIP?
        </td>
        <td className={styles['answer']}>
          The process begins with the Issuer’s submission of its
          Institutional Subscription Form, where it shall designate its
          Underwriters, Arrangers and Selling Agents that will be
          involved in the issuance, listing and registry on-boarding
          activities of the security that will be listed/enrolled on PDEx. <br/> <br/>
          The PDEx Listing Unit will send the Issuer’s designated
          Underwriters and Selling Agents an email inviting them to
          submit their respective Institutional Subscription Forms
          where, among others, they will list their designated
          Authorized Users. <br/> <br/>
          Once the Institutional Subscription Form has been
          completed and submitted to the PDEx Listing Unit, Market
          Services will email the e-SIP Registration Profile Form to the
          Authorized Users. Upon completion of the e-SIP Registration
          Profile Form, the Underwriters and Selling Agents will then
          receive an email containing their credentials to log-on to the
          e-SIP.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          Is e-SIP available
          anytime?
        </td>
        <td className={styles['answer']}>
          e-SIP shall be available each time there will be a new
          security or new tranches of securities to be offered and
          listed on PDEx. After the security or tranche of securities is
          listed, access to e-SIP by Selling Agents and their Applicant
          Clients shall cease.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          How will the
          Underwriter/Selling
          Agents benefit from eSIP in relation to the
          issuance of the
          securities that he is
          underwriting or is
          participating as a Selling
          Agent?
        </td>
        <td className={styles['answer']}>
          The Underwriter who is the Issuer’s designated point person
          can create a listing or enrollment event, set up the terms of
          the security/ies for the listing, identify and designate
          stakeholders (Underwriters, Selling Agents and Registry) to
          the issuance and upload the required documents of PDEx
          and PDTC. <br/><br/>
          Meanwhile, the other Underwriters can view the e-SIP
          listing module, i.e., encoded security details and documents
          submitted by the point person of the Issuer
          The system provides a dashboard for the underwriters to
          monitor the submissions as well as the status of the Issuer’s
          listing application.<br/><br/>
          For Selling Agents, the e-SIP will facilitate the sending of
          invitations to Applicant-Clients to fill up electronic
          Applications to Purchase for the fixed income security (e.g. a
          bond) on offer. It will also allow them to upload multiple
          ATPs for clients they have served manually. The system will
          provide them a dashboard to monitor all of the reservations
          from, and allocations to, Applicant-Clients, and
          electronically submit the set of ATPs to PDTC for onboarding
          on to its Registry book for the Issuer.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          How do we invite
          Applicant-Clients to
          reserve applications for
          a security on offer?
        </td>
        <td className={styles['answer']}>
          An underwriter or Selling Agent designated by the Issuer to
          an issuance can invite Applicant-Clients by sending an
          invitation through the e-SIP. There are two ways to invite
          Applicant-Clients: Single Invite and Bulk Invite. These
          invitations will be sent to the email address of the target
          Applicant-Clients and will stay in their email for 12 hours
          from the time it was sent by the Selling Agent or
          Underwriter. The 12-hour validity is a security feature to
          limit or prevent any unauthorized access to the invitation
          sent by the Selling Agent to its Applicant-Client while
          providing enough time for the same Applicant-Client to
          access their email and open the invitation sent by its Selling
          Agent.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          How many Selling
          Agents/Underwriters’
          users are allowed per
          Institution?
        </td>
        <td className={styles['answer']}>
          Each appointed underwriter and/or selling agent is allowed
          a maximum of 10 users per role, per Institution.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          What are the Business
          Continuity Plans for
          e-SIP?
        </td>
        <td className={styles['answer']}>
          The e-SIP has been developed and shall operate on cloudbased services. Its business continuity plan is therefore
          premised on the cloud platform hosting the portal in global
          multiple-availability zones that each feature their own high
          resiliency and high availability environments.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          What are the security
          features of e-SIP?
        </td>
        <td className={styles['answer']}>
          The e-SIP uses a secure connectivity (https) protocol and
          data are encrypted by default.<br/><br/>
          In addition to assigned usernames and passwords, access
          will be secured with Multi-Factor Authentication (MFA)
          which means that when you attempt to access the portal,
          you are sent an email to your registered email address with
          a One Time Password (OTP). Since you are generally the
          only one with access to your email, you would be notified of
          any attempt to log into your account. The OTP which is
          required to access the portal, will be valid for 3 minutes
          upon receipt. Email confirmations are also sent to your
          registered email address. As a security measure, if no user
          activity on the e-SIP is detected within 15 minutes, the
          system will log out the user.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          What happens if I
          entered a wrong OTP?
        </td>
        <td className={styles['answer']}>
          After three (3) failed attempts, you will be redirected to the
          login page. You can authenticate again by entering your
          username and password. A new OTP will be sent to your
          registered email address.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          Can the Selling Agents
          still accept manual
          Application To Purchase
          (ATPs)?
        </td>
        <td className={styles['answer']}>
          Yes, the appointed Selling Agents of the particular issuance
          can still accept manual ATPs, but these will no longer be
          submitted to PDTC in paper form. The Portal has a bulk
          upload facility, following the sales report template, which
          the Selling Agents can use for clients who applied through
          manual means.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          Will there be a user
          training on how to use
          e-SIP for ApplicantClients?
        </td>
        <td className={styles['answer']}>
          Yes, a video demonstration on the use of the e-SIP will be
          made available. The e-SIP is designed to be a user-friendly,
          easy-to-use platform for Applicant-Clients and shall have an
          FAQ section for Applicant-Clients.
        </td>
      </tr>
      <tr>
        <td  className={`${styles['white-color']} ${styles['question']}`}>
          What is the Data Privacy
          Framework for the data
          stored in e-SIP?
        </td>
        <td className={styles['answer']}>
          All client information collected by the Selling Agent through
          the portal will be maintained until Issue Date and deleted
          thereafter. Consistent with the current framework, the Selling Agent will remain as the Data Collector and the
          Registrar maintains its role as the Data Processor. Further
          details are on the Privacy Notice embedded on e-SIP's
          webpage.
        </td>
      </tr>

      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          Can our existing
          Application To Purchase
          (ATP) system interface
          with e-SIP?
        </td>
        <td className={styles['answer']}>
          Yes, e-SIP was designed to be interoperable with existing
          proprietary systems of the capital market stakeholders.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          Will the due date for the
          submission of the Sales
          Report still be 3
          Business Days before
          Issue Date?
        </td>
        <td className={styles['answer']}>
          Selling Agents may submit up to 9:00 A.M., 1 Business Day
          before the Issue Date. <br/> <br/>
          This is a two-day improvement from the previous manual
          process.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          What are the minimum
          system requirements to
          access e-SIP?
        </td>
        <td className={styles['answer']}>
          e-SIP is accessible via any of the following device operating
          systems and browsers: Windows 10, MacOS, iOS, and
          Android using all modern browsers like Chrome, Firefox,
          Safari and Opera.
        </td>
      </tr>
      <tr>
        <td className={`${styles['white-color']} ${styles['question']}`}>
          What are the minimum
          system requirements to
          access e-SIP?
        </td>
        <td className={styles['answer']}>
          For security purposes, the e-SIP has specifications for the
          password convention.
          <ul>
            <li>
              Combination of Alphanumeric with at least one (1)
              special character
            </li>
            <li>
              Minimum number of characters: 8
            </li>
            <li>
              Allowed special characters: !@#$%^&*()
            </li>
          </ul>
        </td>
      </tr>
      </tbody>
    </Table>
  )
}

export default FAQ;
